export default __webpack_public_path__ + "static/751-49bd47506f1387421eca0583a019a347.gif";